/** Stay22 Allez endpoint segment (path after `/allez/`). Default `roam` = ML vendor pick. */
export type Stay22AllezProvider =
  | 'roam'
  | 'booking'
  | 'expedia'
  | 'hotelscom'
  | 'vrbo'
  | 'agoda'
  | 'tripadvisor';

export const DEFAULT_STAY22_ALLEZ_PROVIDER: Stay22AllezProvider = 'roam';

/** Accommodation vendors on the place modal stay card (Allez outbound; no in-app prices). */
export const PLACE_STAY_INLINE_ALLEZ_PROVIDERS: ReadonlyArray<{
  provider: Stay22AllezProvider;
  label: string;
}> = [
  { provider: 'booking', label: 'Booking.com' },
  { provider: 'expedia', label: 'Expedia' },
  { provider: 'hotelscom', label: 'Hotels.com' },
  { provider: 'vrbo', label: 'Vrbo' },
];

/** Full accommodation vendor list (e.g. expanded flows). */
export const STAY22_ACCOMMODATION_ALLEZ_PROVIDERS: ReadonlyArray<{
  provider: Stay22AllezProvider;
  label: string;
}> = [
  ...PLACE_STAY_INLINE_ALLEZ_PROVIDERS,
  { provider: 'agoda', label: 'Agoda' },
  { provider: 'tripadvisor', label: 'Tripadvisor' },
];
